<template>
  <div>
    <b-modal
      id="enter-modal"
      ref="modal"
      title=""
      hide-footer
      hide-header
      centered
    >
      <div class="header">
        <span class="close-icon">
          <img src="@/assets/svg/close.svg"
               aria-label="close"
               @click="$bvModal.hide('enter-modal')">
        </span>

        <h3>для участия в акции <br> необходимо</h3>
      </div>

      <b-button class="button button-red"
                v-b-modal.registration-modal
                @click="$bvModal.hide('enter-modal')"
                variant="primary">Зарегистрироваться</b-button>

      <b-button class="button button-red"
                v-b-modal.login-modal
                @click="$bvModal.hide('enter-modal')"
                variant="primary">Войти</b-button>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex"
import axios from 'axios'

  export default {
    data() {
      return {
      }
    },

    methods: {
    }
  }
</script>

<style scoped lang="scss">
.button {
  width: 100%;
  margin-bottom: 20px;
}

.button-red {
  border: 1px solid $black !important;
}
</style>
